import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 col-md-6" }
const _hoisted_6 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_8 = { class: "m-2" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = {
  key: 0,
  class: "col-12 col-md-3 d-flex justify-content-start mb-1 mb-md-0"
}
const _hoisted_11 = { class: "col-12 col-md-9" }
const _hoisted_12 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_13 = { class: "form-group mb-0" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { key: 4 }
const _hoisted_19 = { class: "col-12 col-md-6" }
const _hoisted_20 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_21 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_22 = { class: "m-2" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = {
  key: 0,
  class: "col-12 col-md-3 d-flex justify-content-start mb-1 mb-md-0"
}
const _hoisted_25 = { class: "col-12 col-md-9" }
const _hoisted_26 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_27 = { class: "form-group mb-0" }
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { key: 3 }
const _hoisted_32 = { key: 4 }
const _hoisted_33 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_34 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_35 = { class: "m-2" }
const _hoisted_36 = { class: "row" }
const _hoisted_37 = {
  key: 0,
  class: "col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
}
const _hoisted_38 = { class: "col-12 col-md-6" }
const _hoisted_39 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_40 = { class: "form-group mb-0" }
const _hoisted_41 = { class: "d-flex align-items-center" }
const _hoisted_42 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_43 = {
  key: 1,
  class: "text-info"
}
const _hoisted_44 = { key: 2 }
const _hoisted_45 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_46 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_47 = { key: 6 }
const _hoisted_48 = { class: "dropdown" }
const _hoisted_49 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { key: 0 }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { key: 7 }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0" }
const _hoisted_57 = { class: "col-12 col-md-6" }
const _hoisted_58 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_59 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_60 = { class: "m-2" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = {
  key: 0,
  class: "col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0"
}
const _hoisted_63 = { class: "col-12 col-md-6" }
const _hoisted_64 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_65 = { class: "form-group mb-0" }
const _hoisted_66 = { class: "d-flex align-items-center" }
const _hoisted_67 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_68 = {
  key: 1,
  class: "text-info"
}
const _hoisted_69 = { key: 2 }
const _hoisted_70 = {
  key: 0,
  class: "text-nowrap"
}
const _hoisted_71 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_72 = { key: 6 }
const _hoisted_73 = { class: "dropdown" }
const _hoisted_74 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = ["onClick"]
const _hoisted_77 = { key: 0 }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = { key: 7 }
const _hoisted_80 = { class: "row" }
const _hoisted_81 = { class: "col-12 col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0" }
const _hoisted_82 = { class: "col-12 col-md-6" }
const _hoisted_83 = {
  class: "modal fade",
  id: "modal_detail_suivi",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_84 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_85 = { class: "modal-content p-15 p-md-40" }
const _hoisted_86 = { class: "modal-body" }
const _hoisted_87 = {
  class: "modal fade",
  id: "modal_detail_colis",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_88 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_89 = { class: "modal-content p-15 p-md-40" }
const _hoisted_90 = { class: "modal-body" }
const _hoisted_91 = {
  class: "modal fade",
  id: "modal_update",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_92 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_93 = { class: "modal-content p-15 p-md-40" }
const _hoisted_94 = { class: "modal-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!
  const _component_HistoryColis = _resolveComponent("HistoryColis")!
  const _component_DetailsColis = _resolveComponent("DetailsColis")!
  const _component_UpdateParcel = _resolveComponent("UpdateParcel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.paimentNote.note_ref), 1),
        _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("h5", null, [
          _cache[14] || (_cache[14] = _createTextVNode(" Date de création : ", -1)),
          (_ctx.paimentNote.created_at)
            ? (_openBlock(), _createElementBlock("b", _hoisted_3, _toDisplayString(_ctx.getDate(_ctx.paimentNote.created_at)), 1))
            : _createCommentVNode("", true),
          _cache[15] || (_cache[15] = _createTextVNode(" | ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.paimentNote.zone_name), 1),
          _cache[16] || (_cache[16] = _createTextVNode(" | ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.paimentNote.agency_name), 1),
          _cache[17] || (_cache[17] = _createTextVNode(" | ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.paimentNote.for_name), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.paimentNote.statut == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[25] || (_cache[25] = _createElementVNode("div", { class: "card-header pb-2" }, [
                _createElementVNode("h5", null, "List des nouveaux bons (Non Payés)")
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (_ctx.auth.can('ADD_BP_L'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          (_ctx.paimentNote.statut == 0)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                style: {"margin-right":"12px"},
                                class: "btn btn-success",
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.AddNewBP && _ctx.AddNewBP(...args)))
                              }, " Ajouter "))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTearm) = $event)),
                              placeholder: "Chercher",
                              type: "text",
                              class: "form-control d-inline-block"
                            }, null, 512), [
                              [_vModelText, _ctx.searchTearm]
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode(_component_vue_good_table, {
                  columns: _ctx.columnsBP,
                  rows: _ctx.PBRestList,
                  "select-options": {
              selectOnCheckboxOnly: true,
              enabled: true,
              clearSelectionText: 'Annuler',
              selectionText: 'Colis Sélectionés',
              disableSelectInfo: true,
              selectAllByGroup: true,
            },
                  responsive: "",
                  "search-options": {
              enabled: true,
              externalQuery: _ctx.searchTearm,
            },
                  onSelectAll: _ctx.onSelectAllBP,
                  onSelectedRowsChange: _ctx.selectionChangedBP
                }, {
                  "table-row": _withCtx((props) => [
                    (props.column.field === 'infos')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("span", null, _toDisplayString(props.row.zone_name), 1),
                          _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(props.row.agency_name), 1),
                          _cache[20] || (_cache[20] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(props.row.for_name), 1),
                          _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("span", null, _toDisplayString(_ctx.getDate(props.row.created_at)), 1),
                          _cache[22] || (_cache[22] = _createElementVNode("br", null, null, -1))
                        ], 64))
                      : (props.column.field === 'note_ref')
                        ? (_openBlock(), _createElementBlock("b", _hoisted_15, _toDisplayString(props.row.note_ref), 1))
                        : (props.column.field === 'total')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                              _createElementVNode("b", null, _toDisplayString(props.row.total), 1),
                              _cache[23] || (_cache[23] = _createTextVNode(" DH", -1))
                            ]))
                          : (props.column.field === 'reste_amount')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                _createElementVNode("b", null, _toDisplayString(props.row.reste_amount), 1),
                                _cache[24] || (_cache[24] = _createTextVNode(" DH", -1))
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(props.formattedRow[props.column.field]), 1))
                  ]),
                  _: 1
                }, 8, ["columns", "rows", "search-options", "onSelectAll", "onSelectedRowsChange"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "card-header pb-2" }, [
            _createElementVNode("h5", null, "List des bons ajoutés")
          ], -1)),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                (_ctx.auth.can('ADD_BP_L'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      (_ctx.paimentNote.statut == 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            style: {"margin-right":"12px"},
                            class: "btn btn-danger",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.RemoveNewBP && _ctx.RemoveNewBP(...args)))
                          }, " Retirer "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchTearm2) = $event)),
                          placeholder: "Chercher",
                          type: "text",
                          class: "form-control d-inline-block"
                        }, null, 512), [
                          [_vModelText, _ctx.searchTearm2]
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_vue_good_table, {
              columns: _ctx.columnsBP,
              rows: _ctx.BPNewRestList,
              "select-options": {
              selectOnCheckboxOnly: true,
              enabled: true,
              clearSelectionText: 'Annuler',
              selectionText: 'Colis Sélectionés',
              disableSelectInfo: true,
              selectAllByGroup: true,
            },
              responsive: "",
              "search-options": {
              enabled: true,
              externalQuery: _ctx.searchTearm2,
            },
              onSelectAll: _ctx.onSelectAllNewBP,
              onSelectedRowsChange: _ctx.selectionChangedNewBP
            }, {
              "table-row": _withCtx((props) => [
                (props.column.field === 'infos')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("span", null, _toDisplayString(props.row.zone_name), 1),
                      _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(props.row.agency_name), 1),
                      _cache[27] || (_cache[27] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(props.row.for_name), 1),
                      _cache[28] || (_cache[28] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.getDate(props.row.created_at)), 1)
                    ], 64))
                  : (props.column.field === 'total')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                        _createElementVNode("b", null, _toDisplayString(props.row.total), 1),
                        _cache[29] || (_cache[29] = _createTextVNode(" DH", -1))
                      ]))
                    : (props.column.field === 'note_ref')
                      ? (_openBlock(), _createElementBlock("b", _hoisted_30, _toDisplayString(props.row.note_ref), 1))
                      : (props.column.field === 'reste_amount')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                            _createElementVNode("b", null, _toDisplayString(props.row.reste_amount), 1),
                            _cache[30] || (_cache[30] = _createTextVNode(" DH", -1))
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(props.formattedRow[props.column.field]), 1))
              ]),
              _: 1
            }, 8, ["columns", "rows", "search-options", "onSelectAll", "onSelectedRowsChange"])
          ])
        ])
      ])
    ]),
    (_ctx.paimentNote.statut == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _cache[46] || (_cache[46] = _createElementVNode("div", { class: "card-header pb-2" }, [
            _createElementVNode("h5", null, "List des nouveaux colis")
          ], -1)),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                (_ctx.auth.can('ADD_BP_L'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _cache[32] || (_cache[32] = _createElementVNode("label", null, "Voir", -1)),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.users.per_page,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.users.per_page) = $event)),
                        options: [10, 25, 50],
                        clearable: false,
                        class: "per-page-selector d-inline-block mx-50",
                        onInput: _ctx.getRows1
                      }, null, 8, ["modelValue", "onInput"]),
                      (_ctx.paimentNote.statut == 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            style: {"margin-right":"12px"},
                            class: "btn btn-success",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.AddNewColis && _ctx.AddNewColis(...args)))
                          }, " Ajouter "))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchTerm1) = $event)),
                          placeholder: "Chercher",
                          type: "text",
                          class: "form-control d-inline-block"
                        }, null, 512), [
                          [_vModelText, _ctx.searchTerm1]
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode(_component_vue_good_table, {
              columns: _ctx.columns,
              rows: _ctx.rows1,
              "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        },
              responsive: "",
              "search-options": {
          enabled: true,
          externalQuery: _ctx.searchTerm1,
        },
              onSelectAll: _ctx.onSelectAll,
              onSelectedRowsChange: _ctx.selectionChanged
            }, {
              emptystate: _withCtx(() => [
                _createVNode(_component_center, null, {
                  default: _withCtx(() => _cache[33] || (_cache[33] = [
                    _createTextVNode("Aucune entrées correspondants trouvés", -1)
                  ])),
                  _: 1,
                  __: [33]
                })
              ]),
              "table-row": _withCtx((props) => [
                (props.column.field === 'code')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (props.row.replace == 1)
                        ? (_openBlock(), _createElementBlock("h6", _hoisted_42, [
                            _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                            _cache[34] || (_cache[34] = _createElementVNode("i", { class: "icon-repeat" }, null, -1))
                          ]))
                        : (props.row.partial == 1)
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_43, [
                              _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                              _cache[35] || (_cache[35] = _createElementVNode("i", { class: "icon-corner-down-left" }, null, -1))
                            ]))
                          : (_openBlock(), _createElementBlock("h6", _hoisted_44, _toDisplayString(props.row.code), 1))
                    ], 64))
                  : (props.column.field === 'status')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                              style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper(
                  props.row.status_second
                ).code_color,
              })
                            }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                              style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                            }, _toDisplayString(props.row.s_name), 5))
                      ], 64))
                    : (props.column.field === 'price')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("b", null, _toDisplayString(props.row.price), 1),
                          _cache[36] || (_cache[36] = _createTextVNode(" DH ", -1))
                        ], 64))
                      : (props.column.field === 'delivery_time')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            (props.row.delivery_time)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.getDate(props.row.delivery_time)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_46))
                          ], 64))
                        : (props.column.field === 'liv_fees')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                              (
                (props.row.status == 'DELIVERED' ||
                  props.row.status == 'DELIVERED_PARTIAL') &&
                props.row.liv_fees_livred
              )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("b", null, _toDisplayString(props.row.liv_fees_livred), 1),
                                    _cache[37] || (_cache[37] = _createTextVNode(" DH", -1))
                                  ], 64))
                                : _createCommentVNode("", true),
                              (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second == 'REFUSE' &&
                props.row.liv_fees_refused
              )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("b", null, _toDisplayString(props.row.liv_fees_refused), 1),
                                    _cache[38] || (_cache[38] = _createTextVNode(" DH", -1))
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (props.column.field === 'total')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                (
                (props.row.status == 'DELIVERED' ||
                  props.row.status == 'DELIVERED_PARTIAL') &&
                props.row.liv_fees_livred
              )
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("b", null, _toDisplayString(props.row.price - props.row.liv_fees_livred), 1),
                                      _cache[39] || (_cache[39] = _createTextVNode(" DH", -1))
                                    ], 64))
                                  : _createCommentVNode("", true),
                                (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second == 'REFUSE' &&
                props.row.liv_fees_refused
              )
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createElementVNode("b", null, _toDisplayString(0 - props.row.liv_fees_refused), 1),
                                      _cache[40] || (_cache[40] = _createTextVNode(" DH", -1))
                                    ], 64))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : (props.column.field === 'action')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_47, [
                                  _createElementVNode("div", _hoisted_48, [
                                    _cache[44] || (_cache[44] = _createElementVNode("button", {
                                      class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                      type: "button",
                                      "data-bs-toggle": "dropdown",
                                      "aria-expanded": "false"
                                    }, [
                                      _createElementVNode("i", { class: "flaticon-dots" })
                                    ], -1)),
                                    _createElementVNode("ul", _hoisted_49, [
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          class: "dropdown-item d-flex align-items-center",
                                          onClick: ($event: any) => (_ctx.showDetailSuivi(props.row))
                                        }, _cache[41] || (_cache[41] = [
                                          _createElementVNode("i", { class: "flaticon-clock lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Historique ", -1)
                                        ]), 8, _hoisted_50)
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          class: "dropdown-item d-flex align-items-center",
                                          onClick: ($event: any) => (_ctx.showDetails(props.row))
                                        }, _cache[42] || (_cache[42] = [
                                          _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Détails ", -1)
                                        ]), 8, _hoisted_51)
                                      ]),
                                      (
                    _ctx.auth.can('PARCELS') &&
                    (_ctx.user.role_id == 1 || _ctx.user.role_id == 2) &&
                    props.row.status != 'NEW_PARCEL' &&
                    props.row.status != 'WAITING_PICKUP' &&
                    (props.row.status != 'RETURNED' ||
                      props.row.status != 'RETURNED_PARTIAL') &&
                    (props.row.situation != 'Facturé' ||
                      props.row.situation != 'INVOICED')
                  )
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_52, [
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "dropdown-item d-flex align-items-center",
                                              onClick: ($event: any) => (_ctx.showUpdate(props.row))
                                            }, _cache[43] || (_cache[43] = [
                                              _createElementVNode("i", { class: "flaticon-pen" }, null, -1),
                                              _createTextVNode(" Modifier Colis ", -1)
                                            ]), 8, _hoisted_53)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(props.formattedRow[props.column.field]), 1))
              ]),
              _: 1
            }, 8, ["columns", "rows", "search-options", "onSelectAll", "onSelectedRowsChange"]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _cache[45] || (_cache[45] = _createElementVNode("label", null, "Voir", -1)),
                _createVNode(_component_v_select, {
                  modelValue: _ctx.users.per_page,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.users.per_page) = $event)),
                  options: [10, 25, 50],
                  clearable: false,
                  class: "per-page-selector d-inline-block mx-50",
                  onInput: _ctx.getRows1
                }, null, 8, ["modelValue", "onInput"]),
                _createElementVNode("label", null, "de " + _toDisplayString(_ctx.users.total) + " entités", 1)
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createVNode(_component_PaginatorContent, {
                  pagination: _ctx.users,
                  offset: 9,
                  onPaginate: _ctx.getRows1
                }, null, 8, ["pagination", "onPaginate"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_58, [
      _cache[61] || (_cache[61] = _createElementVNode("div", { class: "card-header pb-2" }, [
        _createElementVNode("h5", null, "List des colis ajoutés")
      ], -1)),
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            (_ctx.auth.can('ADD_BP_L'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                  _cache[47] || (_cache[47] = _createElementVNode("label", null, "Voir", -1)),
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.users1.per_page,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.users1.per_page) = $event)),
                    options: [10, 25, 50],
                    clearable: false,
                    class: "per-page-selector d-inline-block mx-50",
                    onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getRows2()))
                  }, null, 8, ["modelValue"]),
                  (_ctx.paimentNote.statut == 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        style: {"margin-right":"12px"},
                        class: "btn btn-danger",
                        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.RemoveNewColis && _ctx.RemoveNewColis(...args)))
                      }, " Supprimer "))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.searchTerm2) = $event)),
                      placeholder: "Chercher",
                      type: "text",
                      class: "form-control d-inline-block"
                    }, null, 512), [
                      [_vModelText, _ctx.searchTerm2]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows2,
          "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        },
          responsive: "",
          "search-options": {
          enabled: true,
          externalQuery: _ctx.searchTerm2,
        },
          onSelectAll: _ctx.onSelectAllColis,
          onSelectedRowsChange: _ctx.selectionChangedColis
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[48] || (_cache[48] = [
                _createTextVNode("Aucune entrées correspondants trouvés", -1)
              ])),
              _: 1,
              __: [48]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_67, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[49] || (_cache[49] = _createElementVNode("i", { class: "icon-repeat" }, null, -1))
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_68, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[50] || (_cache[50] = _createElementVNode("i", { class: "icon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_69, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'status')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({ '--dynamic-bg': _ctx.ColorStatu(props.row.status_second) })
                        }, _toDisplayString(_ctx.resolveStatuParcel(props.row.status_second)), 5))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                      style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                    }, _toDisplayString(props.row.s_name), 5)
                  ], 64))
                : (props.column.field === 'price')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("b", null, _toDisplayString(props.row.price), 1),
                      _cache[51] || (_cache[51] = _createTextVNode(" DH ", -1))
                    ], 64))
                  : (props.column.field === 'delivery_time')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (props.row.delivery_time)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(_ctx.getDate(props.row.delivery_time)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_71))
                      ], 64))
                    : (props.column.field === 'liv_fees')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          (
                (props.row.status == 'DELIVERED' ||
                  props.row.status == 'DELIVERED_PARTIAL') &&
                props.row.liv_fees_livred
              )
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("b", null, _toDisplayString(props.row.liv_fees_livred), 1),
                                _cache[52] || (_cache[52] = _createTextVNode(" DH", -1))
                              ], 64))
                            : _createCommentVNode("", true),
                          (props.row.status == 'REFUSE' && props.row.liv_fees_refused)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createElementVNode("b", null, _toDisplayString(props.row.liv_fees_refused), 1),
                                _cache[53] || (_cache[53] = _createTextVNode(" DH", -1))
                              ], 64))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (props.column.field === 'total')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                            (
                (props.row.status == 'DELIVERED' ||
                  props.row.status == 'DELIVERED_PARTIAL') &&
                props.row.liv_fees_livred
              )
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("b", null, _toDisplayString(props.row.price - props.row.liv_fees_livred), 1),
                                  _cache[54] || (_cache[54] = _createTextVNode(" DH", -1))
                                ], 64))
                              : _createCommentVNode("", true),
                            (props.row.status == 'REFUSE' && props.row.liv_fees_refused)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("b", null, _toDisplayString(0 - props.row.liv_fees_refused), 1),
                                  _cache[55] || (_cache[55] = _createTextVNode(" DH", -1))
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (props.column.field === 'action')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_72, [
                              _createElementVNode("div", _hoisted_73, [
                                _cache[59] || (_cache[59] = _createElementVNode("button", {
                                  class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                  type: "button",
                                  "data-bs-toggle": "dropdown",
                                  "aria-expanded": "false"
                                }, [
                                  _createElementVNode("i", { class: "flaticon-dots" })
                                ], -1)),
                                _createElementVNode("ul", _hoisted_74, [
                                  _createElementVNode("li", null, [
                                    _createElementVNode("button", {
                                      class: "dropdown-item d-flex align-items-center",
                                      onClick: ($event: any) => (_ctx.showDetailSuivi(props.row))
                                    }, _cache[56] || (_cache[56] = [
                                      _createElementVNode("i", { class: "flaticon-clock lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Historique ", -1)
                                    ]), 8, _hoisted_75)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("button", {
                                      class: "dropdown-item d-flex align-items-center",
                                      onClick: ($event: any) => (_ctx.showDetails(props.row))
                                    }, _cache[57] || (_cache[57] = [
                                      _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                                      _createTextVNode(" Détails ", -1)
                                    ]), 8, _hoisted_76)
                                  ]),
                                  (
                    _ctx.auth.can('PARCELS') &&
                    (_ctx.user.role_id == 1 || _ctx.user.role_id == 2) &&
                    props.row.status != 'NEW_PARCEL' &&
                    props.row.status != 'WAITING_PICKUP' &&
                    (props.row.status != 'RETURNED' ||
                      props.row.status != 'RETURNED_PARTIAL') &&
                    (props.row.situation != 'Facturé' ||
                      props.row.situation != 'INVOICED')
                  )
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_77, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "dropdown-item d-flex align-items-center",
                                          onClick: ($event: any) => (_ctx.showUpdate(props.row))
                                        }, _cache[58] || (_cache[58] = [
                                          _createElementVNode("i", { class: "flaticon-pen" }, null, -1),
                                          _createTextVNode(" Modifier Colis ", -1)
                                        ]), 8, _hoisted_78)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "search-options", "onSelectAll", "onSelectedRowsChange"]),
        _createElementVNode("div", _hoisted_80, [
          _createElementVNode("div", _hoisted_81, [
            _cache[60] || (_cache[60] = _createElementVNode("label", null, "Voir", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.users1.per_page,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.users1.per_page) = $event)),
              options: [10, 25, 50],
              clearable: false,
              class: "per-page-selector d-inline-block mx-50",
              onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.getRows2()))
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, "de " + _toDisplayString(_ctx.users1.total) + " entités", 1)
          ]),
          _createElementVNode("div", _hoisted_82, [
            _createVNode(_component_PaginatorContent, {
              pagination: _ctx.users1,
              offset: 9,
              onPaginate: _ctx.getRows2
            }, null, 8, ["pagination", "onPaginate"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_83, [
      _createElementVNode("div", _hoisted_84, [
        _createElementVNode("div", _hoisted_85, [
          _cache[62] || (_cache[62] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Historique Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_86, [
            (_ctx.colisId)
              ? (_openBlock(), _createBlock(_component_HistoryColis, {
                  key: 0,
                  colisId: _ctx.colisId,
                  isOpen: _ctx.isOpen,
                  status: _ctx.statuts
                }, null, 8, ["colisId", "isOpen", "status"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_87, [
      _createElementVNode("div", _hoisted_88, [
        _createElementVNode("div", _hoisted_89, [
          _cache[63] || (_cache[63] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Détails Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_90, [
            (_ctx.coliDetails)
              ? (_openBlock(), _createBlock(_component_DetailsColis, {
                  key: 0,
                  coliDetails: _ctx.coliDetails,
                  isOpen: _ctx.isOpen
                }, null, 8, ["coliDetails", "isOpen"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_91, [
      _createElementVNode("div", _hoisted_92, [
        _createElementVNode("div", _hoisted_93, [
          _cache[64] || (_cache[64] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Modifier Colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Fermer"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_94, [
            (_ctx.rowUpdate)
              ? (_openBlock(), _createBlock(_component_UpdateParcel, {
                  key: 0,
                  rowColis: _ctx.rowUpdate,
                  getRecords: _ctx.getRecords,
                  isOpenEdit: _ctx.isOpenEdit,
                  hideModal: _ctx.hideModal
                }, null, 8, ["rowColis", "getRecords", "isOpenEdit", "hideModal"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}